import { RentalPortalViewingProfile } from '../../RentalPortalViewingProfile'

import * as styles from './RentalPortalViewingMultipleViewTypeListActiveItemPreview.module.css'

function RentalPortalViewingMultipleViewTypeListActiveItemPreview({
  activeItem,
  className = styles.RentalPortalViewingMultipleViewTypeListActiveItemPreview,
  onClose,
  onEntityChange,
}) {
  return (
    <RentalPortalViewingProfile
      isPreview
      layoutProps={{ className }}
      viewingId={activeItem}
      onClosePreview={onClose}
      onEntityChange={onEntityChange}
    />
  )
}

export default RentalPortalViewingMultipleViewTypeListActiveItemPreview
